import { Button } from '@repo/design-system-kit';
import { IconCrossOutlined, IconArrowLeftOutlined } from '@repo/monochrome-icons';
import { useIntl } from 'react-intl';
import cx from 'clsx';
import { useFlow } from '../flow-provider.tsx';
import styles from './flow-header.module.css';

export function FlowHeader({ children }: { children?: React.ReactNode }): JSX.Element {
  const flow = useFlow();
  const intl = useIntl();
  const handleGoBack = (): void => {
    flow.goBack?.(flow.params);
  };

  return (
    <nav className={styles.container}>
      <Button
        aria-label={intl.formatMessage({
          id: 'shared-kit.a11y.buttons.back-aria-label',
          defaultMessage: 'Back',
        })}
        className={cx(flow.goBack === undefined && styles.hideBack)}
        data-testid="flow-header-back"
        iconOnly
        onPress={handleGoBack}
        variant="tertiary"
      >
        <IconArrowLeftOutlined />
      </Button>

      {children}

      <Button
        aria-label={intl.formatMessage({
          id: 'shared-kit.a11y.buttons.close-aria-label',
        })}
        data-testid="flow-header-close"
        iconOnly
        onPress={flow.close}
        variant="tertiary"
      >
        <IconCrossOutlined />
      </Button>
    </nav>
  );
}
